import {
	ChartLine,
	DotsThree,
	Trash,
	UploadSimple,
	UserPlus,
} from "@phosphor-icons/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface SourceRowActionsProps {
	onReadings: () => void;
	onAssign: () => void;
	onUploadFilterlist: () => void;
	onDelete: () => void;
	readingsDisabled: boolean;
	isDeleting: boolean;
}

export function SourceRowActions({
	onReadings,
	onAssign,
	onUploadFilterlist,
	onDelete,
	readingsDisabled,
	isDeleting,
}: SourceRowActionsProps) {
	const { t } = useTranslation();
	const [showDeleteDialog, setShowDeleteDialog] = useState(false);

	return (
		<>
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<Button variant="ghost" size="icon" aria-label={t("common.actions")}>
						<DotsThree className="size-4" weight="bold" />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent align="end">
					<DropdownMenuItem disabled={readingsDisabled} onClick={onReadings}>
						<ChartLine className="size-4" />
						{t("mqttSources.viewReadings")}
					</DropdownMenuItem>
					<DropdownMenuItem onClick={onAssign}>
						<UserPlus className="size-4" />
						{t("mqttSources.assignToReseller")}
					</DropdownMenuItem>
					<DropdownMenuItem onClick={onUploadFilterlist}>
						<UploadSimple className="size-4" />
						{t("filterlistUpload.menuItem")}
					</DropdownMenuItem>
					<DropdownMenuSeparator />
					<DropdownMenuItem
						variant="destructive"
						disabled={isDeleting}
						onClick={() => setShowDeleteDialog(true)}
					>
						<Trash className="size-4" />
						{t("mqttSources.deleteGateway")}
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenu>
			<AlertDialog open={showDeleteDialog} onOpenChange={setShowDeleteDialog}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>{t("mqttSources.deleteTitle")}</AlertDialogTitle>
						<AlertDialogDescription>
							{t("mqttSources.deleteDescription")}
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel>{t("mqttSources.cancel")}</AlertDialogCancel>
						<AlertDialogAction onClick={onDelete}>
							{t("mqttSources.delete")}
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</>
	);
}
